import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ApartmentUnitAdd = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    unitname: "",
    description: "",
    floornumber: "",
    rentamount: "",
    status: "",
    type: "",
  });

  // Fixed Unit Names List
  const unitNames = [
  "Akeza-A1", "Gwiza-A2", "Heza-A3",
  "Beza-B1", "Cyiza-B2", "Ineza-B3",
  "Keza-C1", "Neza-C2", "Gira-C3",
  "Ikaze-D1", "Gwiza-D2", "Ubuntu-D3"
];


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://ikaze-thouse-backend.vercel.app/api/v1/appartmentUnits/create",
        formData
      );
      alert("Apartment unit added successfully!");
      setFormData({
        unitname: "",
        description: "",
        floornumber: "",
        rentamount: "",
        status: "",
        type: "",
      });
      navigate("/manager/apartment-units");
    } catch (error) {
      console.error("Error adding apartment unit:", error);
      alert("Failed to add apartment unit. Please check your inputs.");
    }
  };

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #e0f7fa, #f1f8e9)",
      padding: "20px",
    },
    form: {
      background: "#fff",
      padding: "40px 30px",
      borderRadius: "12px",
      width: "500px",
      maxWidth: "90%",
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
    },
    heading: {
      textAlign: "center",
      marginBottom: "30px",
      color: "#00796b",
      fontSize: "1.8rem",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "25px",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      marginBottom: "15px",
    },
    label: { fontWeight: "bold", marginBottom: "8px", color: "#333" },
    input: {
      padding: "12px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "14px",
      transition: "border-color 0.3s ease",
    },
    select: {
      padding: "12px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "14px",
      transition: "border-color 0.3s ease",
    },
    button: {
      marginTop: "30px",
      width: "100%",
      background: "#00796b",
      color: "white",
      border: "none",
      padding: "14px",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "background 0.3s ease",
    },
  };

  return (
    <div style={styles.container}>
      <form style={styles.form} onSubmit={handleSubmit}>
        <h2 style={styles.heading}>Add Apartment Unit</h2>
        <div style={styles.formGrid}>
          {/* Unit Name */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Unit Name</label>
            <select
              name="unitname"
              value={formData.unitname}
              onChange={handleChange}
              style={styles.select}
              required
            >
              <option value="">Select Unit</option>
              {unitNames.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </div>

          {/* Description */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Description</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter description"
              style={styles.input}
              required
            />
          </div>

          {/* Floor Number */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Floor Number</label>
            <select
              name="floornumber"
              value={formData.floornumber}
              onChange={handleChange}
              style={styles.select}
              required
            >
              <option value="">Select Floor</option>
              <option value="Ground">Ground</option>
              <option value="First">First</option>
              <option value="Second">Second</option>
            </select>
          </div>

          {/* Rent Amount */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Rent Amount</label>
            <input
              type="number"
              name="rentamount"
              value={formData.rentamount}
              onChange={handleChange}
              placeholder="Enter rent amount"
              style={styles.input}
              required
            />
          </div>

          {/* Status */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={styles.select}
              required
            >
              <option value="">Select Status</option>
              <option value="Available">Available</option>
              <option value="Occupied">Occupied</option>
              <option value="Maintenance">Maintenance</option>
            </select>
          </div>

          {/* Type */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Type</label>
            <input
              type="text"
              name="type"
              value={formData.type}
              onChange={handleChange}
              placeholder="Enter unit type"
              style={styles.input}
              required
            />
          </div>
        </div>

        <button type="submit" style={styles.button}>
          Add Unit
        </button>
      </form>
    </div>
  );
};

export default ApartmentUnitAdd;
